import API from '../api-service';

const baseUri = 'content';
const downloadUrl = process.env.VUE_APP_S3_DOWNLOAD_URL;

export default {
  getContentById(syncguid) {
    return API.get(`${baseUri}/${syncguid}`).then(res => {
      return {
        author: res.Author,
        description: res.Description,
        disableScrubbing: !!res.DisableScrubbing,
        duration: res.Duration,
        format: res.Format,
        language: res.Language,
        parentSyncguid: res.ParentCourseGuid,
        productionDate: res.ProductionDate,
        releaseDate: res.ReleaseDate,
        retired: !!res.Retired,
        retiredDate: res.RetiredDate,
        syncguid: res.SyncGuid,
        title: res.Title,
        isProcessed: !!res.VideoProcessed,
      };
    });
  },
  getThumbnail(syncguid) {
    return API.get(`${baseUri}/${syncguid}/thumbnail`);
  },
  getSupportMaterials(syncguid) {
    return API.get(`${baseUri}/${syncguid}/materials`);
  },
  downloadSupportMaterial(syncguid, file) {
    return API.get(`${baseUri}/${syncguid}/materials/${file}`).then(res => {
      const path = '/Content';
      const url = downloadUrl + path + res.split(path)[1];
      window.open(url, '_blank');
    });
  },

  getInteractions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/interactions`).then(res => {
      let titleCount = 1;
      res.sort((a, b) => (a.start > b.start ? 1 : -1));
      res.forEach(interaction => {
        if (interaction.type === 'section_title') {
          interaction.position = titleCount;
          titleCount++;
        } else {
          if (interaction.type === 'poll') interaction.icon = 'bzl-poll';
          else if (interaction.type === 'note') interaction.icon = 'bzl-note';
          else interaction.icon = 'bzl-question';
        }
      });
      return res;
    });
  },
  getInteractionResponses(syncguid, params) {
    return API.get(`${baseUri}/${syncguid}/interactions/responses`, params);
  },
  postInteractionResponse(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/interactions/responses`, body);
  },
  getResources(syncguid) {
    return API.get(`${baseUri}/${syncguid}/resources`);
  },
  getQuiz(syncguid) {
    return API.get(`${baseUri}/${syncguid}/quiz`);
  },
  gradeQuiz(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/quiz`, body);
  },
  getCaptions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/captions`);
  },
};
